import { render, staticRenderFns } from "./CallcentreTeamManage.vue?vue&type=template&id=2c0b9832&"
import script from "./CallcentreTeamManage.vue?vue&type=script&lang=js&"
export * from "./CallcentreTeamManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports